/**
 * Which timezone an event is DISPLAYED in — the one rule every event surface
 * shares (docs/date-formatting/design.md, "Event timezone rule").
 *
 *   - Online (the location is a URL): the viewer's zone. There is no venue.
 *   - In-person with a resolvable stored zone: the event's zone.
 *   - Anything else (legacy null, unresolvable like "Factory"): the viewer's
 *     zone, so it reads exactly like an online event with no extra code path.
 *
 * `datetime.ts` imports this module and this module imports `datetime.ts`.
 * Both only define functions, so the cycle is safe; do not add top-level calls.
 */
import { getBrowserTimezone, isValidTimezone } from './datetime';
import { getLocationUrl } from './eventLocation';

export interface DisplayZoneEvent {
  location?: string | null;
  timezone?: string | null;
}

export const isOnlineEvent = (event: Pick<DisplayZoneEvent, 'location'>): boolean =>
  getLocationUrl(event.location) !== null;

export const getEventDisplayZone = (event: DisplayZoneEvent): string => {
  const viewerZone = getBrowserTimezone();
  if (isOnlineEvent(event)) return viewerZone;
  const stored = event.timezone;
  return stored && isValidTimezone(stored) ? stored : viewerZone;
};
